@if(!isMobileDevice){
<div class="position-relative">
  <div class="sidebar">
    <div class="d-flex flex-column dp-label">
      <div class="sidebar-header">
        <div class="global-img"></div>
        <span class="global-text">dp.global</span>
      </div>
    </div>

    <div class="side-bar-wrapper d-flex flex-column">
      <div *ngFor="let item of navBar; trackBy: trackByFn; let i = index"
        class="d-flex flex-column side-bar-padding cursor-pointer mainMenu" (click)="selectNavItem(item, i)" [ngClass]="
          i === selectedNavItemIndex && item.subNav.length
            ? 'sidebarBorder'
            : i === selectedNavItemIndex
            ? 'side-bar-active '
            : ''
        ">
        <div class="labelSec d-flex justify-content-between">
          <div class="innerLabel d-flex">
            <div class="icon" [style.background-image]="
                i === selectedNavItemIndex ? item.activeImageUrl : item.imageUrl
              "></div>
            <span class="sidebar-text">{{ item.label }} </span>
          </div>
          <div class="dropArrowOuter">
            <span class="dropArrow ms-3" *ngIf="item.subNav.length"><i
                [ngClass]="i === selectedNavItemIndex ? 'rotateIco' : ''" class="fa-solid fa-angle-down"></i></span>
          </div>
        </div>
        @if(item.subNav.length){
        <div class="side-bar-subnav">
          <div *ngFor="let subItem of item.subNav; trackBy: trackByFn"
            class="d-flex align-items-center sub-side-bar-padding cursor-pointer" style="flex-basis: 100%"
            (click)="clickSubNavItem($event, subItem.label)"
            [routerLink]="['./' + item.webRoute + '/' + subItem.webRoute]" [routerLinkActive]="['side-bar-active']">
            <div class="icon" [style.background-image]="
                subItem.label === selectedNavItem
                  ? subItem.activeImageUrl
                  : subItem.imageUrl
              "></div>
            <span class="sidebar-text">{{ subItem.label }}</span>
          </div>
        </div>
        }
      </div>
    </div>
    <!-- <hr class="sideNavHr" /> -->
    <div class="d-flex flex-column side-bar-gap">
      <div class="d-flex align-items-center side-bar-padding innerLabel">
        <img [src]="userIconPath" alt="User" />
        <span class="sidebar-text ">{{ fullName }}</span>
      </div>
      <div (click)="showColorCodes = !showColorCodes" [ngClass]="showColorCodes ? 'sidebarBorder' : ''"
        class="d-flex flex-column cursor-pointer side-bar-padding">
        <div #tooltip="matTooltip" matTooltipPosition="below" matTooltip="{{ themeName }}"
          class="appearanceHead d-flex align-items-center">
          <img [src]="getThemeIconPath" alt="Theme" />
          <span class="sidebar-text ">Appearance - {{ themeName }}</span>
        </div>
        @if(showColorCodes){
        <div class="side-bar-subnav">
          @for(color of colorCodes; track color){
          <div (click)="toggleColorSchema(color.value, color.name, color.icon)"
            class="d-flex align-items-center p-2 gap-2 cursor-pointer" style="flex-basis: 100%">
            <div class="icon"><img [src]="getThemeModeIconPath(color.icon)" [alt]="color.icon" srcset=""></div>
            <span class=" sidebar-text">{{ color.name }}</span>
          </div>
          }
        </div>
        }
      </div>
      <div class="d-flex align-items-center side-bar-padding innerLabel">
        <img src="../../../../assets/images/list-black.png" alt="Theme" />
        <span class="sidebar-text ">{{ role }}</span>
      </div>

      <div class="d-flex align-items-center cursor-pointer side-bar-padding innerLabel" (click)="logOut()">
        <img [src]="logoutIconPath" alt="Logout" />
        <span class="sidebar-text ">Log out</span>
      </div>
    </div>
  </div>
  <div class="routerBody">
    <router-outlet></router-outlet>
  </div>
</div>
} @else if (isMobileDevice) {
<div class="topbar d-flex justify-content-between p-3 mt-2">
  <div class="leftPanel">
    <div class="sideNavToggle" (click)="showNavbar = !showNavbar"></div>
    <div class="routeName">
      <span>{{ pageTitle }}</span>
    </div>
  </div>
  <div class="rightPanel">
    @if(currentRoute.includes('/dp-3-0/defaulters')){
    <div class="heart" (click)="openWishlistDialog('centralizedReach')"></div>
    }@else if(currentRoute.includes('/dp-2-0/find-details')){
    <div class="heart" (click)="openWishlistDialog('centralizedFd')"></div>
    }@else if(currentRoute.includes('/datum/print-&-monitor')){
    <div class="heart" (click)="openWishlistDialog('centralizedPm')"></div>
    }
    <!-- @else if(currentRoute.includes('/all-countries')){
    <div class="heart" (click)="openWishlistDialog('centralizedPm')"></div>
    }@else { } -->
    <div class="notification"></div>
  </div>
</div>
<div class="position-relative">
  @if(showNavbar){
  <div class="mobSideNavContainer">
    <div (click)="showNavbar = false" class="falseSideNavCloseDiv"></div>
    <div class="sidebarMob" #scrollMe>
      <div class="d-flex flex-column dp-label">
        <div class="d-flex align-items-center">
          <div class="sidebar-header">
            <div class="global-img"></div>
            <span class="global-text">dp.global</span>
          </div>
        </div>
      </div>
      <div class="side-bar-wrapper d-flex flex-column">
        <div *ngFor="let item of navBar; trackBy: trackByFn; let i = index"
          class="d-flex flex-column side-bar-padding cursor-pointer mainMenu" (click)="selectNavItem(item, i)"
          [ngClass]="
            i === selectedNavItemIndex && item.subNav.length
              ? 'sidebarBorder'
              : i === selectedNavItemIndex
              ? 'side-bar-active'
              : ''
          ">
          <div class="labelSec d-flex justify-content-between">
            <div class="innerLabel d-flex">
              <div class="icon" [style.background-image]="
                  i === selectedNavItemIndex
                    ? item.activeImageUrl
                    : item.imageUrl
                "></div>
              <span class=" sidebar-text">{{ item.label }} </span>
            </div>
            <div class="dropArrowOuter">
              <span class="dropArrow ms-3" *ngIf="item.subNav.length"><i
                  [ngClass]="i === selectedNavItemIndex ? 'rotateIco' : ''" class="fa-solid fa-angle-down"></i></span>
            </div>
          </div>
          @if(item.subNav.length){
          <div class="side-bar-subnav">
            <div *ngFor="
                let subItem of item.subNav;
                trackBy: trackByFn;
                let i = index
              " class="d-flex align-items-center sub-side-bar-padding cursor-pointer" style="flex-basis: 100%"
              (click)="clickSubNavItem($event, subItem.label)"
              [routerLink]="['./' + item.webRoute + '/' + subItem.webRoute]" [routerLinkActive]="['side-bar-active']">
              <div class="icon" [style.background-image]="
                  subItem.label === selectedNavItem
                    ? subItem.activeImageUrl
                    : subItem.imageUrl
                "></div>
              <span class=" sidebar-text">{{ subItem.label }}</span>
            </div>
          </div>
          }
        </div>
      </div>
      <!-- <hr class="sideNavHr" /> -->
      <div class="d-flex flex-column side-bar-gap">
        <div class="d-flex align-items-center side-bar-padding" style="gap: 12px;">
          <img [src]="userIconPath" alt="User" />
          <span class="sidebar-text ">{{ fullName }}</span>
        </div>
        <div (click)="showColorCode()" [ngClass]="showColorCodes ? 'sidebarBorder' : ''"
          class="d-flex flex-column side side-bar-padding">
          <div class="appearanceHead d-flex align-items-center">
            <img [src]="getThemeIconPath" alt="Theme" />
            <span class="sidebar-text ">Appearance - {{ themeName }}</span>
          </div>

          @if(showColorCodes){

          <div class="side-bar-subnav">
            @for(color of colorCodes; track color){
            <div (click)="toggleColorSchema(color.value, color.name, color.icon)"
              class="d-flex align-items-center side-bar-padding cursor-pointer" style="flex-basis: 100%; gap: 12px;">
              <div class="icon"><img [src]="getThemeModeIconPath(color.icon)" [alt]="color.icon" srcset=""></div>
              <span class=" sidebar-text">{{ color.name }}</span>
            </div>
            }
          </div>
          }
        </div>
        <div class="d-flex align-items-center side-bar-padding" style="gap: 12px;">
          <img src="../../../../assets/images/list-black.png" alt="Theme" />
          <span class="sidebar-text ">{{ role }}</span>
        </div>
        <div class="d-flex align-items-center cursor-pointer side-bar-padding" (click)="logOut()" style="gap: 12px;">
          <img [src]="logoutIconPath" alt="Logout" />
          <span class="sidebar-text ">Log out</span>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="routerBody">
    <router-outlet></router-outlet>
  </div>
</div>

}
<!-- <app-loader [isLoading]="isLoading"></app-loader> -->